//
// Module for the Withholding What-If Index Tab views
//
rs.module("content/participant/benefit/withholdingwhatif/index/tab",

    ["common/select-helper", "common/visibility", "pg/numerical-input"],

    function (selectHelper, visibility, numericalInput) {

        // Initialize the page
        function initialize(jsSelectors, codeValues, IsStateTab, ajaxUrls) {

            // Unpack jsSelectors
            var newContainer = $.js(jsSelectors.newContainer);
            var resultsContainer = $.js(jsSelectors.resultsContainer, { required: false });

            var effectiveDatePicker = newContainer.js(jsSelectors.effectiveDate);
            var stateSelect = newContainer.js(jsSelectors.stateSelector, { required: IsStateTab });
            var electionSelect = newContainer.js(jsSelectors.electionSelector);
            var flatAmountInput = newContainer.js(jsSelectors.flatAmountInput);
            var percentOfTaxableInput = newContainer.js(jsSelectors.percentOfTaxableInput);
            var extraWithholdingField = newContainer.js(jsSelectors.extraWithholdingField);
            var extraWithholdingInput = extraWithholdingField.js(jsSelectors.extraWithholding);
            var extraAmountPerPaymentInput = newContainer.js(jsSelectors.extraAmountPerPayment, { required: !IsStateTab });
            var filingStatusSelect = newContainer.js(jsSelectors.filingStatus);
            var allowancesField = newContainer.js(jsSelectors.allowancesField);
            var allowancesInput = allowancesField.js(jsSelectors.allowances);
            var isCalculated = newContainer.js(jsSelectors.isCalculated);
            var w4PChangeEffectiveDate = newContainer.js(jsSelectors.w4PChangeEffectiveDate, { required: !IsStateTab });

            var allowanceDE4PW4PInput = newContainer.js(jsSelectors.allowanceDE4PW4PInput, {required: IsStateTab} );
            var addWithholdingAllowanceInput = newContainer.js(jsSelectors.addWithholdingAllowanceInput, { required: IsStateTab });

            var newFederalW4PFields = newContainer.js(jsSelectors.newFederalW4PFields, { required: !IsStateTab });
            var
                annualJobPayInput,
                otherAnnualPensionInput,
                totalJobPensionIncomeInput,
                childDependentCreditInput,
                otherDependentCreditInput,
                otherTaxCreditInput,
                totalTaxCreditInput;

            if (!IsStateTab) {
                annualJobPayInput = newFederalW4PFields.js(jsSelectors.annualJobPayInput);
                otherAnnualPensionInput = newFederalW4PFields.js(jsSelectors.otherAnnualPensionInput);
                totalJobPensionIncomeInput = newFederalW4PFields.js(jsSelectors.totalJobPensionIncomeInput);

                childDependentCreditInput = newFederalW4PFields.js(jsSelectors.childDependentCreditInput);
                otherDependentCreditInput = newFederalW4PFields.js(jsSelectors.otherDependentCreditInput);
                otherTaxCreditInput = newFederalW4PFields.js(jsSelectors.otherTaxCreditInput);
                totalTaxCreditInput = newFederalW4PFields.js(jsSelectors.totalTaxCreditInput);

                numericalInput.registerSumInputs(totalJobPensionIncomeInput, 2, annualJobPayInput, otherAnnualPensionInput);

                numericalInput.registerSumInputs(totalTaxCreditInput, 2, childDependentCreditInput, otherDependentCreditInput, otherTaxCreditInput);

                newFederalW4PFields.find('input').change(clearResults);
                extraAmountPerPaymentInput.change(clearResults);
            }

            // Get Select Helper(s) for updating drop down options and properties.
            var filingStatusSelectHelper = selectHelper.getHelper(filingStatusSelect);
            var stateSelectHelper = selectHelper.getHelper(stateSelect);

            // Hook up on change events
            effectiveDatePicker.change(_.debounce(function () {
                clearResults();

                if (IsStateTab) {
                    ManageStateSelect();
                } else {
                    ToggleFederalW4PDisplay();
                }
            }, 500));

            electionSelect.change(electionSelected);
            flatAmountInput.change(clearResults);
            percentOfTaxableInput.change(clearResults);
            extraWithholdingInput.change(clearResults);
            filingStatusSelect.change(clearResults);
            allowancesInput.change(clearResults);
            allowanceDE4PW4PInput.change(clearResults);
            addWithholdingAllowanceInput.change(clearResults);

            // On election change, enable or disable the fields
            function electionSelected() {
                ToggleAmountFields(electionSelect.val());
                ToggleFederalW4PDisplay();
                clearResults();
            }

            // Populate the state drop down options
            function ManageStateSelect() {
                if (effectiveDatePicker.val() && effectiveDatePicker.valid()) {
                    stateSelectHelper.loadOptionsFrom(
                        ajaxUrls.populateStatesUrl,
                        { effectiveDate: effectiveDatePicker.val(), selectedState: stateSelect.val() },
                        { withBlank: true });
                }
            }

            // Enable the appropriate fields based on the given election
            function ToggleAmountFields(electionCodeKey) {
                if (electionCodeKey == codeValues.flat ||
                    electionCodeKey == codeValues.percent) {

                    filingStatusSelectHelper.setValue('');
                    filingStatusSelect.clearErrors();
                    filingStatusSelectHelper.setDisabled(true);

                    allowancesInput.val('').clearErrors();
                    allowancesInput.prop('disabled', true);

                    allowanceDE4PW4PInput.val('').clearErrors();
                    allowanceDE4PW4PInput.prop('disabled', true);

                    addWithholdingAllowanceInput.val('').clearErrors();
                    addWithholdingAllowanceInput.prop('disabled', true);

                    extraWithholdingInput.val('').clearErrors();
                    extraWithholdingInput.prop('disabled', true);
                    if (!IsStateTab) {
                        extraAmountPerPaymentInput.val('').clearErrors();
                        extraAmountPerPaymentInput.prop('disabled', true);
                    }

                    if (electionCodeKey == codeValues.flat) {
                        flatAmountInput.prop('disabled', false);

                        percentOfTaxableInput.val('').clearErrors();
                        percentOfTaxableInput.prop('disabled', true);
                    } else {
                        flatAmountInput.val('').clearErrors();
                        flatAmountInput.prop('disabled', true);

                        percentOfTaxableInput.prop('disabled', false);
                    }
                } else if (
                    electionCodeKey == codeValues.taxTable ||
                    electionCodeKey == codeValues.taxTableAndExtra) {

                    flatAmountInput.val('').clearErrors();
                    flatAmountInput.prop('disabled', true);

                    percentOfTaxableInput.val('').clearErrors();
                    percentOfTaxableInput.prop('disabled', true);

                    // enable applicable fields
                    filingStatusSelectHelper.setDisabled(false);
                    allowancesInput.prop('disabled', false);
                    allowanceDE4PW4PInput.prop('disabled', false);
                    addWithholdingAllowanceInput.prop('disabled', false);

                    if (electionCodeKey == codeValues.taxTable) {
                        extraWithholdingInput.val('').clearErrors();
                        extraWithholdingInput.prop('disabled', true);
                        if (!IsStateTab) {
                            extraAmountPerPaymentInput.val('').clearErrors();
                            extraAmountPerPaymentInput.prop('disabled', true);
                        }
                    } else {
                        extraWithholdingInput.prop('disabled', false);
                        if (!IsStateTab) {
                            extraAmountPerPaymentInput.prop('disabled', false);
                        }
                    }
                } else {
                    flatAmountInput.val('').clearErrors();
                    flatAmountInput.prop('disabled', true);

                    percentOfTaxableInput.val('').clearErrors();
                    percentOfTaxableInput.prop('disabled', true);

                    filingStatusSelectHelper.setValue('');
                    filingStatusSelect.clearErrors();
                    filingStatusSelectHelper.setDisabled(true);

                    allowancesInput.val('').clearErrors();
                    allowancesInput.prop('disabled', true);

                    allowanceDE4PW4PInput.val('').clearErrors();
                    allowanceDE4PW4PInput.prop('disabled', true);

                    addWithholdingAllowanceInput.val('').clearErrors();
                    addWithholdingAllowanceInput.prop('disabled', true);

                    extraWithholdingInput.val('').clearErrors();
                    extraWithholdingInput.prop('disabled', true);
                    if (!IsStateTab) {
                        extraAmountPerPaymentInput.val('').clearErrors();
                        extraAmountPerPaymentInput.prop('disabled', true);
                    }
                }
            }

            // Display appropriate fields based on if effective date is w4PChangeEffectiveDate or later
            function ToggleFederalW4PDisplay() {

                // If this is the Federal tab and a valid effective date has been entered...
                if (!IsStateTab && effectiveDatePicker.val() && effectiveDatePicker.valid()) {

                    // show the fields if the entered effective date is >= than the w4PChangeEffectiveDate
                    let showNewW4PFields = new Date(effectiveDatePicker.val() + 'T00:00:00') >= new Date(w4PChangeEffectiveDate.val());

                    let taxTablePlusExtraSelected = electionSelect.val() == codeValues.taxTableAndExtra;
                    let taxTableOptionSelected = taxTablePlusExtraSelected || electionSelect.val() == codeValues.taxTable;
                    let enableNewW4PFields = showNewW4PFields && taxTableOptionSelected;

                    extraWithholdingInput.prop('disabled', !taxTablePlusExtraSelected || showNewW4PFields);
                    extraAmountPerPaymentInput.prop('disabled', !taxTablePlusExtraSelected || !showNewW4PFields);

                    visibility.setVisible(extraWithholdingField, !showNewW4PFields);

                    visibility.setVisible(allowancesField, !showNewW4PFields);

                    newFederalW4PFields.find('input').not(extraAmountPerPaymentInput).each(function () {
                        $(this).prop('disabled', !enableNewW4PFields);

                        if (!enableNewW4PFields) {
                            $(this).val('$0.00');
                        }
                    });

                    visibility.setVisible(newFederalW4PFields, showNewW4PFields);
                }
            }

            // Hide Results Container
            function clearResults() {
                resultsContainer.hide();
                isCalculated.val(false);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);